<div class="content notification-campaign-dashboard">
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Notification Campaigns</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">Super Admin</li>
          <li class="breadcrumb-item active" aria-current="page">Notification Campaigns</li>
        </ol>
      </nav>
    </div>
    <div class="ms-2 d-flex gap-2">
      <button class="btn btn-outline-primary d-flex align-items-center" (click)="goToTemplates()">
        <i class="ti ti-template me-2"></i>Manage Templates
      </button>
      <button class="btn btn-primary d-flex align-items-center" (click)="openCreateModal()">
        <i class="ti ti-circle-plus me-2"></i>New Campaign
      </button>
    </div>
  </div>

  <div class="row">
    <div class="card">
      <div
        class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
      >
        <h5>Campaign List</h5>
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
          <div class="me-3" *ngIf="campaigns.length > 0">
            <select
              class="form-select form-select-sm"
              [(ngModel)]="pageLimit"
              (change)="onPageLimitChange()"
            >
              <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">{{ limit }}</option>
            </select>
          </div>
          <div class="dropdown me-3">
            <select class="form-select" [(ngModel)]="filterStatus" (change)="onFilterChange()">
              <option value="">All Status</option>
              <option *ngFor="let s of statusOptions" [value]="s">{{ s | capitalize }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="card-body p-0">
        <div class="custom-datatable-filter table-responsive">
          <table class="table datatable">
            <thead class="thead-light">
              <tr>
                <th>Title</th>
                <th>Channel</th>
                <th>Recipients</th>
                <th>Status</th>
                <th>Progress</th>
                <th>Scheduled/Sent At</th>
                <th>Source</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of campaigns">
                <td>{{ c.title }}</td>
                <td>{{ channelLabel(c.channel) }}</td>
                <td>{{ c.totalRecipients }}</td>
                <td>
                  <span [ngClass]="statusClass(c.status)">{{ c.status | capitalize }}</span>
                </td>
                <td class="progress-cell">
                  <div class="progress-bar-bg">
                    <div class="progress-bar-fill" [style.width.%]="progressPercent(c)"></div>
                  </div>
                  <span class="progress-text">{{ progressPercent(c) }}%</span>
                </td>
                <td>
                  {{
                    c.scheduledAt
                      ? (c.scheduledAt | date: 'dd MMM yyyy, hh:mm a')
                      : c.startedAt
                        ? (c.startedAt | date: 'dd MMM yyyy, hh:mm a')
                        : '-'
                  }}
                </td>
                <td>
                  <span
                    class="badge"
                    [ngClass]="
                      c.source === 'super_admin' || c.source === 'business'
                        ? 'bg-secondary'
                        : 'bg-success'
                    "
                  >
                    {{
                      c.source === 'work_anniversary_cron'
                        ? 'Work Anniversary'
                        : c.source === 'birthday_cron'
                          ? 'Birthday'
                          : (c.source || 'manual' | capitalize)
                    }}
                  </span>
                </td>
                <td class="actions-cell">
                  <button *ngIf="canStop(c.status)" class="btn-danger-sm" (click)="stop(c)">
                    Stop
                  </button>
                  <button *ngIf="canCancel(c.status)" class="btn-warn-sm" (click)="cancel(c)">
                    Cancel
                  </button>
                  <button *ngIf="canRetry(c.status)" class="btn-secondary-sm" (click)="retry(c)">
                    Retry
                  </button>
                  <!-- ✅ View — naya page -->
                  <a
                    href="javascript:void(0);"
                    class="me-2"
                    (click)="viewHistory(c)"
                    title="View History"
                  >
                    <i class="ti ti-eye"></i>
                  </a>
                </td>
              </tr>
              <tr *ngIf="!loading && campaigns.length === 0">
                <td colspan="8" class="empty-row">No campaigns found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between ms-2">
        <div>
          Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
          {{ totalCount }} entries
        </div>
        <div class="has-text-centered mt-3">
          <app-pagination
            [currentPage]="currentPage"
            [pageSize]="pageLimit"
            [totalRows]="totalCount"
            (pageChange)="onPageChange($event)"
          ></app-pagination>
        </div>
      </div>
    </div>
  </div>

  <!-- Create Campaign Modal -->
  <div
    class="modal-overlay"
    *ngIf="showCreateModal"
    role="button"
    tabindex="0"
    aria-label="Close modal"
    (click)="closeCreateModal()"
    (keydown.escape)="closeCreateModal()"
  >
    <div
      class="modal"
      role="dialog"
      aria-modal="true"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      <h3>New Notification Campaign</h3>

      <!-- ================= CONTENT MODE ================= -->
      <div class="send-row mt-3">
        <label class="send-label">Content</label>

        <label class="send-radio">
          <input
            type="radio"
            name="contentMode"
            value="template"
            [(ngModel)]="form.contentMode"
            (change)="onContentModeChange()"
          />
          <span>Use Template</span>
        </label>

        <label class="send-radio">
          <input
            type="radio"
            name="contentMode"
            value="custom"
            [(ngModel)]="form.contentMode"
            (change)="onContentModeChange()"
          />
          <span>Custom</span>
        </label>
      </div>

      <!-- ================= TEMPLATE ================= -->
      <ng-container *ngIf="form.contentMode === 'template'">
        <label class="mt-3">Select Template</label>

        <select
          class="form-select"
          [(ngModel)]="form.selectedTemplateId"
          (change)="onTemplateSelect()"
        >
          <option value="" disabled>Choose a template</option>

          <option *ngFor="let t of templates" [value]="t.id">
            {{ t.title }} —
            {{ t.businessId ? 'Business Override' : 'Default' }}
            ({{ t.occasion | capitalize }})
          </option>
        </select>
      </ng-container>

      <!-- ================= CHANNEL ================= -->
      <div *ngIf="form.contentMode === 'custom'">
        <div class="send-row mt-3">
          <label class="mt-3">Channel</label>

          <label class="send-radio">
            <input type="radio" name="channelMode" value="push" [(ngModel)]="form.channel" />
            <span>Push Notification</span>
          </label>

          <label class="send-radio">
            <input type="radio" name="channelMode" value="email" [(ngModel)]="form.channel" />
            <span>Email</span>
          </label>
        </div>
      </div>

      <!-- ================= TITLE ================= -->

      <label class="mt-3">
        Title

        <span *ngIf="isPushSelected" class="char-counter" [class.over-limit]="isTitleOverLimit">
          ({{ titleCharCount }}/{{ PUSH_TITLE_MAX_LENGTH }})
        </span>
      </label>

      <input
        type="text"
        class="form-control"
        [(ngModel)]="form.title"
        placeholder="e.g. Maintenance Notice"
        [class.is-invalid]="isTitleOverLimit"
      />

      <small class="text-danger" *ngIf="isTitleOverLimit">
        Title is too long for push notifications (max {{ PUSH_TITLE_MAX_LENGTH }} characters).
      </small>

      <!-- ================= MESSAGE ================= -->

      <label class="mt-3">
        Message

        <span *ngIf="isPushSelected" class="char-counter" [class.over-limit]="isMessageOverLimit">
          ({{ messageCharCount }}/{{ PUSH_MESSAGE_MAX_LENGTH }})
        </span>
      </label>

      <ckeditor
        [editor]="Editor"
        [config]="editorConfig"
        [(ngModel)]="form.message"
        (ready)="onEditorReady($event)"
        class="notification-editor"
      ></ckeditor>

      <small class="text-danger" *ngIf="isMessageOverLimit">
        Message is too long for push notifications (max {{ PUSH_MESSAGE_MAX_LENGTH }} characters).
      </small>

      <!-- ================= PLACEHOLDERS ================= -->

      <div class="d-flex flex-wrap gap-2 mt-2">
        <small class="text-muted w-100 mb-1"> Click to insert: </small>

        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          *ngFor="let p of availablePlaceholders"
          (click)="insertPlaceholder(p.key)"
        >
          {{ p.label }}
        </button>
      </div>

      <!-- ================= PREVIEW ================= -->

      <div class="preview-box mt-3" *ngIf="form.message">
        <label class="text-muted"> Preview (sample data) </label>

        <div class="preview-content">
          <strong>{{ titlePreview }}</strong>

          <div [innerHTML]="messagePreview"></div>
        </div>
      </div>

      <!-- ================= RECIPIENTS ================= -->

      <label class="mt-3">
        Businesses (all their users will be included)
        <small class="text-muted" *ngIf="isBusinessLocked"> — Locked to template's business </small>
      </label>
      <ng-select
        [items]="businesses$ | async"
        bindValue="id"
        [multiple]="true"
        placeholder="Select businesses (optional)"
        [searchable]="true"
        [clearable]="!isBusinessLocked"
        [readonly]="isBusinessLocked"
        [searchFn]="customBusinessSearchFn"
        [(ngModel)]="form.businessIds"
      >
        <ng-template ng-label-tmp let-item="item">{{ item.businessName | capitalize }}</ng-template>
        <ng-template ng-option-tmp let-item="item">{{
          item.businessName | capitalize
        }}</ng-template>
      </ng-select>

      <label class="mt-3">
        Individual Users (in addition to businesses above)
        <small class="text-muted" *ngIf="isBusinessLocked">
          — Showing only users from template's business
        </small>
      </label>
      <ng-select
        [items]="filteredUsers$ | async"
        bindValue="id"
        [multiple]="true"
        placeholder="Select individual users (optional)"
        [searchable]="true"
        [clearable]="true"
        [searchFn]="customUserSearchFn"
        [(ngModel)]="form.individualUserIds"
      >
        <ng-template ng-label-tmp let-item="item"
          >{{ item.firstName }} {{ item.lastName }}</ng-template
        >
        <ng-template ng-option-tmp let-item="item"
          >{{ item.firstName }} {{ item.lastName }} — {{ item.email }}</ng-template
        >
      </ng-select>

      <!-- ================= SEND MODE ================= -->

      <div class="send-row mt-4">
        <label class="send-label"> Send </label>

        <label class="send-radio">
          <input
            type="radio"
            name="sendMode"
            value="now"
            [(ngModel)]="form.sendMode"
            (change)="onSendModeChange('now')"
          />

          <span>Now</span>
        </label>

        <label class="send-radio">
          <input
            type="radio"
            name="sendMode"
            value="later"
            [(ngModel)]="form.sendMode"
            (change)="onSendModeChange('later')"
          />

          <span>Schedule for later</span>
        </label>

        <label class="send-radio">
          <input
            type="radio"
            name="sendMode"
            value="recurring"
            [(ngModel)]="form.sendMode"
            (change)="onSendModeChange('recurring')"
          />

          <span>Recurring</span>
        </label>
      </div>

      <!-- ================= SCHEDULE LATER ================= -->

      <div class="schedule-container mt-3" *ngIf="form.sendMode === 'later'">
        <div class="row">
          <div class="col-md-4">
            <label> Date </label>

            <input
              type="date"
              class="form-control"
              [(ngModel)]="form.scheduledDate"
              [min]="minScheduleDate"
              (change)="onScheduleDateChange()"
            />
          </div>

          <div class="col-md-4">
            <label> Time </label>

            <input
              type="time"
              class="form-control"
              [(ngModel)]="form.scheduledTime"
              [min]="form.scheduledDate === minScheduleDate ? minScheduleTime : '00:00'"
            />
          </div>

          <div class="col-md-4">
            <label> Timezone </label>

            <select class="form-select" [(ngModel)]="form.timezone">
              <option *ngFor="let tz of timezones" [value]="tz">
                {{ tz }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- ================= RECURRING ================= -->

      <div class="schedule-container mt-3" *ngIf="form.sendMode === 'recurring'">
        <div class="row">
          <div class="col-md-4">
            <label> Repeat </label>

            <select
              class="form-select"
              [(ngModel)]="form.scheduleType"
              (change)="onScheduleTypeChange()"
            >
              <option value="daily">Daily</option>

              <option value="birthday">Birthday</option>

              <option value="work_anniversary">Work Anniversary</option>
            </select>
          </div>

          <div class="col-md-4">
            <label> Time </label>

            <input type="time" class="form-control" [(ngModel)]="form.scheduledTime" />
          </div>

          <div class="col-md-4">
            <label> Timezone </label>

            <select class="form-select" [(ngModel)]="form.timezone">
              <option *ngFor="let tz of timezones" [value]="tz">
                {{ tz }}
              </option>
            </select>
          </div>
        </div>

        <!-- Birthday Info -->
        <div class="alert alert-info mt-3 mb-0" *ngIf="form.scheduleType === 'birthday'">
          <i class="ti ti-calendar-heart me-2"></i>

          This campaign will automatically send birthday wishes to eligible employees every day at
          the selected time.
        </div>

        <!-- Anniversary Info -->
        <div class="alert alert-info mt-3 mb-0" *ngIf="form.scheduleType === 'work_anniversary'">
          <i class="ti ti-award me-2"></i>

          This campaign will automatically send work anniversary wishes to eligible employees every
          day at the selected time.
        </div>
      </div>

      <!-- ================= ERROR ================= -->

      <p class="error-text" *ngIf="createError">
        {{ createError }}
      </p>

      <!-- ================= ACTIONS ================= -->

      <div class="modal-actions">
        <button class="btn btn-light" type="button" (click)="closeCreateModal()">Cancel</button>

        <button
          class="btn btn-primary"
          type="button"
          (click)="submitCampaign()"
          [disabled]="submitting"
        >
          {{ submitting ? 'Sending...' : form.sendMode === 'later' ? 'Schedule' : 'Send Now' }}
        </button>
      </div>
    </div>
  </div>
</div>
